import { useQuery } from "@tanstack/react-query";

import loggedInOrganizationsApi from "../../apis/logged_in_organizations.js";
import { QUERY_KEYS } from "../../constants";

const { LOGGED_IN_ORGANIZATIONS_LIST } = QUERY_KEYS;

const useFetchLoggedInOrganizations = email =>
  useQuery({
    queryKey: [LOGGED_IN_ORGANIZATIONS_LIST],
    queryFn: () => loggedInOrganizationsApi.fetch(email),
  });

export { useFetchLoggedInOrganizations };
